import { trackEvent } from './trackEvent';

export function trackModalView(
  modalName: string,
  properties: Record<string, unknown> = {},
) {
  trackEvent(`Modal View: ${modalName}`, properties);
}
